import React, { Suspense } from 'react';
import RouteFallback from '../../components/RouteFallback';
import { isNativeApp } from '../../utils/platformUtils';

const WebLoginPage = React.lazy(() => import('../Login/LoginPage'));
const NativeLoginPage = React.lazy(() => import('./NativeLoginPage'));
const WebSignupPage = React.lazy(() => import('../SignupAddAnimal/SignupAddAnimalPage'));
const NativeSignupPage = React.lazy(() => import('./NativeSignupPage'));

/**
 * Sur Capacitor : écrans auth natifs (Sign in with Apple + Google).
 * Sur web : pages marketing / AuthLayout existantes.
 */
export function AuthLoginRoute() {
  const Page = isNativeApp() ? NativeLoginPage : WebLoginPage;
  return (
    <Suspense fallback={<RouteFallback />}>
      <Page />
    </Suspense>
  );
}

export function AuthSignupRoute() {
  const Page = isNativeApp() ? NativeSignupPage : WebSignupPage;
  return (
    <Suspense fallback={<RouteFallback />}>
      <Page />
    </Suspense>
  );
}
